import { render, staticRenderFns } from "./btn-outline.mpx?vue&type=template&id=18c106ee&isComponent&outputPath=components%2Fbtn-outline27f51a97%2Findex"
import script from "./btn-outline.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-outline27f51a97%2Findex"
export * from "./btn-outline.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-outline27f51a97%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports